(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-featured-list"] && !Shopify.designMode) return;
  try {
    
        if (!customElements.get('blog-featured-search')) {
          /* The CSS above treats 1024 as tablet, so desktop starts one pixel up.
             theme.mediaQueries.lg would put the form back in the header at 1024. */
          const DESKTOP_QUERY = '(min-width: 1025px)';

          /**
          * The dropdown from sections/blog.liquid, cut down to one control. Where
          * blog-listing.js moves a bare div, this moves the whole form: an input
          * outside its form cannot submit, and submitting is all this search does.
          */
          class BlogFeaturedSearch extends HTMLElement {
          constructor() {
          super();
          this.toggle = this.querySelector('.js-featured-search-toggle');
          this.drop = this.querySelector('.js-featured-search-drop');
          this.form = this.querySelector('.blog-featured-list__tools');
          this.input = this.querySelector('input[type="search"]');

          if (!this.toggle || !this.drop || !this.form) return;

            // Where the form belongs on desktop.
            this.home = this.form.parentElement;

            this.breakpointChangeHandler = this.place.bind(this);
            this.desktopMq = window.matchMedia(DESKTOP_QUERY);

            this.toggle.addEventListener('click', this.handleToggle.bind(this));
            this.drop.addEventListener('keyup', this.handleKeyup.bind(this));
            document.addEventListener('click', this.handleDocClick.bind(this));
            window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
            this.desktopMq.addEventListener('change', this.breakpointChangeHandler);

            this.place();
            }

            disconnectedCallback() {
            window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
            this.desktopMq?.removeEventListener('change', this.breakpointChangeHandler);
            }

            /**
            * Puts the form inline in the header on desktop and in the dropdown below
            * tablet. It is moved rather than duplicated, so one field keeps its
            * value, its label and its form.
            */
            place() {
            const isDesktop = this.desktopMq.matches;

            if (isDesktop) {
              // The toggle stays put, so appending lands the form back after it.
              if (this.form.parentElement !== this.home) this.home.appendChild(this.form);
                this.close();
                } else if (this.form.parentElement !== this.drop) {
                this.drop.appendChild(this.form);
                }
                }

                /**
                * @param {object} evt - 'click' on the search icon.
                */
                handleToggle(evt) {
                evt.preventDefault();

                if (this.drop.classList.contains('is-open')) {
                  this.close(true);
                  } else {
                  this.open();
                  }
                  }

                  /**
                  * @param {object} evt - 'keyup' inside the dropdown.
                  */
                  handleKeyup(evt) {
                  if (evt.key === 'Escape') this.close(true);
                    }

                    /**
                    * Closes the dropdown on a click outside of it.
                    * @param {object} evt - 'click' on the document.
                    */
                    handleDocClick(evt) {
                    if (!this.drop.classList.contains('is-open')) return;
                      if (this.drop.contains(evt.target) || this.toggle.contains(evt.target)) return;

                        this.close();
                        }

                        open() {
                        this.drop.classList.add('is-open');
                        this.toggle.setAttribute('aria-expanded', 'true');

                        // Deferred: the field cannot take focus until the panel is visible.
                        if (this.input) setTimeout(() => this.input.focus());
                          }

                          /**
                          * @param {boolean} [returnFocus=false] - Send focus back to the icon, which
                          *   closing would otherwise leave on a field that has just gone hidden.
                          */
                          close(returnFocus = false) {
                          if (!this.drop.classList.contains('is-open')) return;

                            this.drop.classList.remove('is-open');
                            this.toggle.setAttribute('aria-expanded', 'false');

                            if (returnFocus) this.toggle.focus();
                              }
                              }

                              customElements.define('blog-featured-search', BlogFeaturedSearch);
                              }
                              
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blog-menu')) {
    class BlogMenu extends HTMLElement {
      constructor() {
        super();
        this.disclosure = this.querySelector('.blog-menu__disclosure');
        this.toggle = this.querySelector('.blog-menu__toggle');

        this.breakpointChangeHandler = this.init.bind(this);

        this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
        this.disclosure.addEventListener('transitionend', this.handleTransition.bind(this));
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);

        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }

      /**
       * Sets the 'open' state of the disclosure: open on desktop, closed on mobile.
       * @param {?object} evt - Event object ('on:breakpoint-change'), absent on first run.
       */
      init(evt) {
        // No transition on page load, only when a breakpoint is crossed.
        const transition = !!evt;

        if (window.matchMedia(theme.mediaQueries.md).matches) {
          this.open(transition);
        } else {
          this.close(transition);
        }
      }

      /**
       * Handles a 'click' event on the menu toggle.
       * @param {object} evt - Event object.
       */
      handleToggleClick(evt) {
        evt.preventDefault();

        if (this.disclosure.open) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handles a 'transitionend' event - hides the nav once it has finished closing.
       * @param {object} evt - Event object.
       */
      handleTransition(evt) {
        if (evt.target.closest('details') !== this.disclosure) return;
        this.endClose();
      }

      /**
       * Opens the nav.
       * @param {boolean} [transition=true] - Open action has a CSS transition.
       */
      open(transition = true) {
        if (this.closeTimeout) clearTimeout(this.closeTimeout);

        this.disclosure.open = true;
        this.disclosure.classList.remove('is-closing');

        if (transition) {
          // Slight delay required before starting the transition.
          setTimeout(() => this.disclosure.classList.add('is-open'));
        } else {
          this.disclosure.classList.add('is-open');
        }
      }

      /**
       * Closes the nav.
       * @param {boolean} [transition=true] - Close action has a CSS transition.
       */
      close(transition = true) {
        this.disclosure.classList.remove('is-open');

        if (transition) {
          this.disclosure.classList.add('is-closing');
          // Fallback, in case no transition runs (e.g. reduced motion) so no 'transitionend' fires.
          this.closeTimeout = setTimeout(this.endClose.bind(this), 400);
        } else {
          this.disclosure.classList.remove('is-closing');
          this.disclosure.open = false;
        }
      }

      /**
       * Completes a transitioned close.
       */
      endClose() {
        if (!this.disclosure.classList.contains('is-closing')) return;

        if (this.closeTimeout) clearTimeout(this.closeTimeout);
        this.disclosure.classList.remove('is-closing');
        this.disclosure.open = false;
      }
    }

    customElements.define('blog-menu', BlogMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-review"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-slider')) {
    /**
     * Advances the reviews one card at a time below 1024px, filling a bar as it
     * counts down to the next. Above that all three are on screen and it does
     * nothing. Scrolling does the moving, so a swipe works with no help.
     */
    class ReviewSlider extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('.js-review-track');
        this.progress = this.querySelector('.js-review-progress');
        this.slides = this.querySelectorAll('.blog-view__review');

        // One card has nowhere to advance to.
        if (!this.track || this.slides.length < 2) return;

        this.duration = parseInt(this.dataset.slideDuration, 10) || 8000;
        this.index = 0;

        this.breakpointChangeHandler = this.start.bind(this);

        this.track.addEventListener('scroll', this.handleScroll.bind(this));
        // WCAG 2.2.2: moving content stops while it is being used.
        this.addEventListener('focusin', this.stop.bind(this));
        this.addEventListener('focusout', this.start.bind(this));
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }

      /**
       * @returns {boolean} Whether the cards should be advancing at all.
       */
      shouldAutoplay() {
        return !window.matchMedia(theme.mediaQueries.lg).matches
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      start() {
        this.stop();
        if (!this.shouldAutoplay()) return;

        this.timer = setInterval(this.advance.bind(this), this.duration);
        this.runProgress();
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        this.setProgress(0, 0);
      }

      advance() {
        this.index = (this.index + 1) % this.slides.length;

        // Offsets rather than a width multiple, so any padding is accounted for.
        this.track.scrollTo({
          left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft,
          behavior: 'smooth'
        });

        this.runProgress();
      }

      /**
       * Fills the bar across one card's turn, from empty.
       */
      runProgress() {
        this.setProgress(0, 0);

        // Commits the reset before the fill, or the browser collapses the two
        // into one and nothing appears to move.
        void this.progress?.offsetWidth;

        this.setProgress(100, this.duration);
      }

      /**
       * @param {number} percent - Width to animate to.
       * @param {number} ms - Duration, or 0 to jump.
       */
      setProgress(percent, ms) {
        if (!this.progress) return;

        this.progress.style.transition = ms ? `width ${ms}ms linear` : 'none';
        this.progress.style.width = `${percent}%`;
      }

      /**
       * Follows a swipe, and restarts the countdown from wherever it lands. Our
       * own scrolling sets this.index first, so it reads as no change here.
       */
      handleScroll() {
        if (this.scrollTimer) clearTimeout(this.scrollTimer);

        this.scrollTimer = setTimeout(() => {
          const index = Math.round(this.track.scrollLeft / (this.slides[0].offsetWidth || 1));
          if (index === this.index) return;

          this.index = index;
          if (this.timer) this.start();
        }, 120);
      }
    }

    customElements.define('review-slider', ReviewSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
// Inline minimal safety init if asset fails (optional placeholder)
document.currentScript && document.currentScript.parentElement && document.currentScript.parentElement.classList.remove('no-js');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
